<template>
    <div>
        <ResumeCard
            :title="`Skills : ${group.name}`"
            icon="mdi-code-json"
            color="indigo"
            width="100%">
            <v-row class="pa-4">
                <v-col
                    cols="12"
                    sm="4"
                    class="skills font-weight-light px-5">
                    <SkillBar
                        v-for="skill in group.skills"
                        :key="skill.label"
                        v-bind="skill" />
                    <!-- One dash per group; clicking one stops the auto-cycle. -->
                    <v-row class="skills__pager">
                        <v-icon
                            v-for="(item, i) in skillGroups"
                            :key="item.name"
                            class="mx-1"
                            :color="i === index ? 'yellow' : 'secondary'"
                            :aria-label="item.name"
                            @click="select(i)">
                            mdi-minus
                        </v-icon>
                    </v-row>
                </v-col>
                <v-col
                    v-if="$vuetify.breakpoint.smAndUp"
                    cols="12"
                    sm="8">
                    <CodeScreen />
                </v-col>
            </v-row>
        </ResumeCard>
    </div>
</template>

<script>
import { computed } from 'vue';
import { skillGroups } from '@/data/skills';
import { useAutoCycle } from '@/composables/useAutoCycle';
import ResumeCard from './ResumeCard.vue';
import SkillBar from './SkillBar.vue';
import CodeScreen from './CodeScreen.vue';

/** Skill groups shown one at a time (auto-cycling), next to the code screen. */
export default {
    name: 'SkillsPanel',
    components: { ResumeCard, SkillBar, CodeScreen },
    setup() {
        const { index, select } = useAutoCycle(skillGroups.length, 5000);

        return {
            skillGroups,
            index,
            select,
            group: computed(() => skillGroups[index.value]),
        };
    },
};
</script>

<style scoped>
.skills {
    min-height: 560px;
    position: relative;
}
.skills__pager {
    position: absolute;
    bottom: 0px;
    width: 100%;
}
</style>
